export const oneOnOneLandingPageReactQueryKeys = {
  oneOnOneLandingPageDetails: 'oneOnOneLandingPageDetails',
  oneOnOneActiveArchiveCount: 'oneOnOneActiveArchiveCount',
};
